
  // セールバナーの表示設定 
window.addEventListener("load", () => {
      const removeBanner = document.querySelector(".saleBanner");
      const removePicture = document.querySelector(".saleBanner .bannerPicture");
    console.log(removeBanner);
      if(removeBanner) {
            function buildSaleDateTime(date, time, includeTimezone) {
                if (!date || !time) return "";
                const trimmedDate = date.trim();
                const trimmedTime = time.trim();
                if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmedDate) || !/^\d{2}:\d{2}$/.test(trimmedTime)) return "";
                const dateTime = `${trimmedDate}T${trimmedTime}:00`;
                return includeTimezone ? `${dateTime}+09:00` : dateTime;
            }

            function removeBannerOnDateTime() {
                const saleSchedule = window.customSaleSchedule || {};
                let now = new Date();
                let displayStartDate = new Date(buildSaleDateTime(saleSchedule.startDate, saleSchedule.startTime, false) || "2026-04-24T12:00:00"); 
                let displayEndDate = new Date(buildSaleDateTime(saleSchedule.endDate, saleSchedule.endTime, false) || "2026-04-27T10:00:00"); 
        
                if (now < displayStartDate || now > displayEndDate) {
                    removeBanner.style.display = "none";
                    removeBanner.style.opacity = "0";
                    removePicture.style.height = "0";
                } else {
                  removeBanner.style.display = "grid";
                  removeBanner.style.opacity = "1";
                  removePicture.style.height = "auto";
                }
            }
            removeBannerOnDateTime();
        }


  });
